import { flow } from 'fp-ts/function';
import { compact, keys, map } from 'lodash/fp';
import { SupportedPaymentMethod } from '@mews/enums';
import { omitFalsyValues } from '@mews/fp';
import { createHandler } from '@mews/std';

const supportedPaymentMethodToEnum = createHandler<string, SupportedPaymentMethod | null>(
    {
        ideal: SupportedPaymentMethod.Ideal,
        paymentCard: SupportedPaymentMethod.PaymentCard,
        applePay: SupportedPaymentMethod.ApplePay,
        googlePay: SupportedPaymentMethod.GooglePay,
        sepaDirectDebit: SupportedPaymentMethod.SepaDirectDebit,
        payPal: SupportedPaymentMethod.PayPal,
    },
    null
);

export const convertSupportedPaymentMethods = flow<
    [Record<string, boolean>],
    Record<string, boolean>,
    string[],
    Array<SupportedPaymentMethod | null>,
    Array<SupportedPaymentMethod>
>(omitFalsyValues, keys, map(supportedPaymentMethodToEnum), compact);
